import React from 'react';
import { useAuth } from '../../contexts/AuthContext';

interface HeaderProps {
  title?: string;
  searchPlaceholder?: string;
  onSearch?: (query: string) => void;
  actions?: React.ReactNode;
}

const Header: React.FC<HeaderProps> = ({
  title,
  searchPlaceholder = 'Search...',
  onSearch,
  actions,
}) => {
  const { user } = useAuth();

  const initials = user?.firstName && user?.lastName
    ? `${user.firstName.charAt(0)}${user.lastName.charAt(0)}`.toUpperCase()
    : user?.fullName?.charAt(0)?.toUpperCase() || 'A';

  return (
    <header className="h-16 flex items-center justify-between px-8 bg-white border-b border-slate-200 flex-shrink-0">
      <div className="flex items-center gap-4 w-1/3">
        {title && <h2 className="text-lg font-bold mr-4">{title}</h2>}
        <div className="relative w-full max-w-md">
          <span className="material-symbols-outlined absolute left-3 top-1/2 -translate-y-1/2 text-slate-400 text-xl">
            search
          </span>
          <input
            type="text"
            placeholder={searchPlaceholder}
            onChange={(e) => onSearch?.(e.target.value)}
            className="w-full bg-slate-50 border border-slate-200 rounded-lg pl-10 pr-4 py-2 text-sm focus:ring-1 focus:ring-primary text-slate-700 placeholder:text-slate-400"
          />
        </div>
      </div>
      <div className="flex items-center gap-6">
        {actions}
        <button className="relative p-2 text-slate-400 hover:text-primary transition-colors">
          <span className="material-symbols-outlined text-2xl">notifications</span>
          <span className="absolute top-2 right-2 w-2 h-2 bg-primary rounded-full border-2 border-white" />
        </button>
        <div className="h-8 w-[1px] bg-slate-200 mx-2" />
        <div className="flex items-center gap-3">
          <div className="text-right hidden sm:block">
            <p className="text-sm font-semibold text-slate-700 leading-none">
              {user?.fullName || 'Admin User'}
            </p>
            <p className="text-[10px] text-primary font-bold uppercase tracking-wider mt-1">
              {user?.role?.name || 'Super Admin'}
            </p>
          </div>
          <div className="w-10 h-10 rounded-full bg-primary/10 border border-primary/20 flex items-center justify-center text-primary font-bold">
            {initials}
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
